import React from "react";
import { Input } from "./common/Input";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";
import { Field, Form } from "react-jsonschema-form-validation";

export const QuestionnaireWeight = ({ def, onRespond, currentResponse }) => {
	const weightChange = (unit, value, tgt) => {
		const kg2lb = 2.20462;
		const lbsInSt = 14;

		switch (unit) {
			case "metric":
				tgt.weightKg = parseFloat(value || 0);
				tgt.weightLbs = tgt.weightKg * kg2lb;
				tgt.weightUkSt = parseInt(tgt.weightLbs / lbsInSt, 10);
				tgt.weightUkLbs = tgt.weightLbs % lbsInSt;
				break;

			case "lbs":
				tgt.weightLbs = parseFloat(value || 0);
				tgt.weightKg = tgt.weightLbs / kg2lb;
				tgt.weightUkSt = parseInt(tgt.weightLbs / lbsInSt, 10);
				tgt.weightUkLbs = tgt.weightLbs % lbsInSt;
				break;

			case "ukst":
				tgt.weightUkSt = parseFloat(value || 0);
				tgt.weightUkLbs = tgt.weightUkLbs || 0;
				tgt.weightLbs = tgt.weightUkSt * lbsInSt + tgt.weightUkLbs;
				tgt.weightKg = tgt.weightLbs / kg2lb;
				break;

			case "uklbs":
				tgt.weightUkLbs = parseFloat(value || 0);
				tgt.weightUkSt = tgt.weightUkSt || 0;
				tgt.weightLbs = tgt.weightUkSt * lbsInSt + tgt.weightUkLbs;
				tgt.weightKg = tgt.weightLbs / kg2lb;
				break;

			default:
				break;
		}

		tgt.option = value.trim().length === 0 ? null : tgt.weightKg;
	};

	const onChangeMetric = (e) => {
		const val = e.target.value;

		const response = {};
		response.id = def.id;
		response.value = value;
		weightChange("metric", val, response.value);
		response.value.display[0] = val;

		onRespond(response);
	};

	const onChangeLbs = (e) => {
		const val = e.target.value;

		const response = {};
		response.id = def.id;
		response.value = value;
		weightChange("lbs", val, response.value);
		response.value.display[0] = val;

		onRespond(response);
	};

	const onChangeUkSt = (e) => {
		const val = e.target.value;

		const response = {};
		response.id = def.id;
		response.value = value;
		weightChange("ukst", val, response.value);
		response.value.display[0] = val;

		onRespond(response);
	};

	const onChangeUkLbs = (e) => {
		const val = e.target.value;

		const response = {};
		response.id = def.id;
		response.value = value;
		weightChange("uklbs", val, response.value);
		response.value.display[1] = val;

		onRespond(response);
	};

	const changeUnits = (unit) => {
		const response = {};
		response.id = def.id;
		response.value = value;
		response.value.preferredUnits = unit;

		switch (unit) {
			case "metric":
				response.value.display[0] =
					isNaN(response.value.weightKg) || response.value.weightKg === null
						? ""
						: (response.value.weightKg || 0).toFixed(2);
				response.value.display[1] = undefined;
				break;

			case "lbs":
				response.value.display[0] =
					isNaN(response.value.weightLbs) || response.value.weightLbs === null
						? ""
						: (response.value.weightLbs || 0).toFixed(1);
				response.value.display[1] = undefined;
				break;

			default:
				response.value.display[0] =
					isNaN(response.value.weightUkSt) || response.value.weightUkSt === null
						? ""
						: (response.value.weightUkSt || 0).toFixed(0);
				response.value.display[1] =
					isNaN(response.value.weightUkLbs) ||
					response.value.weightUkLbs === null
						? ""
						: (response.value.weightUkLbs || 0).toFixed(1);
				break;
		}

		onRespond(response);
	};

	const value =
		currentResponse && typeof currentResponse.value === "object"
			? currentResponse.value
			: {
					preferredUnits: "metric",
					weightKg: null,
					weightLbs: null,
					weightUkSt: null,
					weightUkLbs: null,
					display: ["", ""],
			  };

	return (
		<div className={"mx-2"}>
			<QuestionnaireHeader def={def} />

			<Form schema={{ type: "object" }}>
				<h3 className={"font-bold mt-4 mb-1 sm:mb-4 text-black"}>
					Please select your preferred units
				</h3>

				<div className="mb-4">
					<div className={"w-full flex items-center"}>
						<div className={`radioSlider mx-2`}>
							<Field
								type="radio"
								name="units"
								id="unitskg"
								className={"hidden radioOption"}
								value={"unitskg"}
								checked={value.preferredUnits === "metric"}
								onClick={() => changeUnits("metric")}
							/>
							<label
								htmlFor={"unitskg"}
								className={`option ${
									value.preferredUnits === "metric"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Kg
							</label>
						</div>

						<div className={`radioSlider mx-2`}>
							<Field
								type="radio"
								name="units"
								id="unitslbs"
								className={"hidden radioOption"}
								value={"unitskg"}
								checked={value.preferredUnits === "lbs"}
								onClick={() => changeUnits("lbs")}
							/>
							<label
								htmlFor={"unitslbs"}
								className={`option ${
									value.preferredUnits === "lbs"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Lbs
							</label>
						</div>

						<div className={`radioSlider mx-2`}>
							<Field
								type="radio"
								name="units"
								id="unitsstlbs"
								className={"hidden radioOption"}
								value={"unitskg"}
								checked={value.preferredUnits === "stlbs"}
								onClick={() => changeUnits("stlbs")}
							/>
							<label
								htmlFor={"unitsstlbs"}
								className={`option ${
									value.preferredUnits === "stlbs"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								St and lbs
							</label>
						</div>
					</div>
				</div>
			</Form>

			{value.preferredUnits === "metric" && (
				<div className={"w-full pb-3 xs:pb-6 text-black flex items-center"}>
					<Input
						id="inputkg"
						value={value.display[0]}
						onChange={onChangeMetric}
						placeholder={"Kg"}
						multiline={false}
						required={false}
						inputType={"number"}
						fullWidth={false}
						sx={{ width: "100px" }}
					/>
					<div className={"ml-2"}>Kg</div>
				</div>
			)}

			{value.preferredUnits === "lbs" && (
				<div className={"w-full pb-3 xs:pb-6 text-black flex items-center"}>
					<Input
						id="inputlbs"
						value={value.display[0]}
						onChange={onChangeLbs}
						placeholder={"lbs"}
						multiline={false}
						required={false}
						inputType={"number"}
						fullWidth={false}
						sx={{ width: "100px" }}
					/>
					<div className={"ml-2"}>lbs</div>
				</div>
			)}

			{value.preferredUnits === "stlbs" && (
				<div className={"w-full pb-3 xs:pb-6 text-black flex items-center"}>
					<Input
						id="inputuklbs"
						value={value.display[0]}
						onChange={onChangeUkSt}
						placeholder={"st"}
						multiline={false}
						required={false}
						inputType={"number"}
						fullWidth={false}
						sx={{ width: "100px" }}
					/>
					<div className={"ml-2 mr-8"}>st</div>

					<Input
						id="inputukst"
						value={value.display[1]}
						onChange={onChangeUkLbs}
						placeholder={"lbs"}
						multiline={false}
						required={false}
						inputType={"number"}
						fullWidth={false}
						sx={{ width: "100px" }}
					/>
					<div className={"ml-2"}>lbs</div>
				</div>
			)}

			<QuestionnaireFooter def={def} />
		</div>
	);
};
